import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

export const useMultilingualText = (tKey, area) => {
  const { t } = useTranslation(area);
  const translatedText = t(tKey);
  return parse(translatedText);
};
